import { Chip, Grid, Tooltip, Typography } from "@mui/material";
import { green } from "@mui/material/colors";
import React from "react";

export default function DetailSecurity({ filters }) {
  const groupBy = (key) => (array) =>
    array.reduce(
      (objectsByKeyValue, obj) => ({
        ...objectsByKeyValue,
        [obj[key]]: (objectsByKeyValue[obj[key]] || []).concat(obj),
      }),
      {},
    );
  const groupFilterName = groupBy("filterName");
  const filtersGrouped = groupFilterName(filters);

  return (
    <Grid
      container
      alignContent="center"
      alignItems="center"
      direction="row"
      justify="center"
      style={{ textAlign: "center" }}
    >
      {/* <Grid item alignContent="center" alignItems="center" >
                <Typography variant={'h5'} color="textPrimary" style={{ textAlign: 'center', width: '100%' }}>Filters</Typography>
            </Grid> */}
      {Object.keys(filtersGrouped).map((fg) => {
        return (
          <>
            <Grid item alignContent="center" alignItems="center" style={{ margin: "auto" }}>
              <Typography color="textPrimary" style={{ textAlign: "center" }} variant={"h6"}>
                {fg}
              </Typography>
            </Grid>
            <Grid item alignContent="center" alignItems="center" style={{ margin: "auto" }}>
              {filtersGrouped[fg].map((obj, i) => (
                <Tooltip key={`Tooltip-${obj?.value}-${i}`} title={<>{`${obj?.value}`}</>}>
                  <Chip
                    key={`chip-${obj?.value}-${i}`}
                    color="primary"
                    label={
                      <>
                        {obj?.value.length < 30 ? (
                          <p>
                            <b>{obj?.value}</b> - {obj?.groupName}
                          </p>
                        ) : (
                          <p>{obj?.groupName}</p>
                        )}
                      </>
                    }
                    size="small"
                    style={{
                      color: green[700],
                      borderColor: green[300],
                      margin: 3,
                    }}
                    variant="outlined"
                  />
                </Tooltip>
              ))}
            </Grid>
          </>
        );
      })}
    </Grid>
  );
}
